import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-filter-icon',
  imports: [],
  templateUrl: './filter-icon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './filter-icon.component.scss',
})
export class FilterIconComponent {}
